import I18n from 'I18n';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import { DEFAULT_DEBUG, DEBUG_EVENTS } from 'reporting-visualizations/constants/debug';
import { useEffect } from 'react';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function NoData({
  isMobile,
  visualizationDebug = DEFAULT_DEBUG
}) {
  useEffect(() => {
    visualizationDebug.set(DEBUG_EVENTS.NO_DATA_VISUALIZATION, {});
  }, [visualizationDebug]);
  return /*#__PURE__*/_jsxs(UIFlex, {
    direction: "column",
    align: "center",
    justify: "center",
    children: [/*#__PURE__*/_jsx(UIBox, {
      children: /*#__PURE__*/_jsx(Illustration, {
        name: "empty-state-charts",
        width: isMobile ? '60%' : '100%',
        marginBlockEnd: isMobile ? '0' : '600',
        "data-test-id": "report-no-data"
      })
    }), /*#__PURE__*/_jsx(UIBox, {
      children: I18n.text('error-messages.empty.message')
    })]
  });
}